/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestBuildOutputLimitSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_BUILD_OUTPUT_LIMIT')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([codecNumber, codecString])),
    ],
]);
export class NewAutoTestBuildOutputLimitSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestBuildOutputLimitSettingParser.decode(input).map(res => new NewAutoTestBuildOutputLimitSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestBuildOutputLimitSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestBuildOutputLimitSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestBuildOutputLimitSettingParser.schema();
    }
}
